export const companyLicenseLocales = {
  en: {
    companyLicenses: {
      tab: "Company licenses",
      title: "Company licenses",
      intro: "Licenses used by your company, with status, validity, capacity and the users on each license.",
      companyIntro: "Licenses used by {{company}}, with status, validity, capacity and the users on each license.",
      partialNote: "Only the company administrator sees every user's license assignment; you see your own.",
      total: "Total licenses",
      usable: "In use",
      expiringSoon: "Expiring in 30 days",
      expired: "Expired",
      seats: "Users / capacity",
      nextExpiry: "Next expiry: {{date}}",
      products: "Products",
      search: "Search code, product, company or user",
      statusFilter: "Status",
      all: "All",
      export: "Export CSV",
      renew: "Request renewal",
      details: "Details",
      noLicenses: "No licenses are linked to your company yet.",
      noMatch: "No licenses match the filter.",
      loadError: "Licenses could not be loaded.",
      daysLeft: "{{count}} days left",
      lastDay: "Last day",
      expiredAgo: "Expired {{count}} days ago",
      openEnded: "No end date",
      defaultCapacity: "default limit",
      usersTitle: "Users on this license",
      noUsers: "No user is assigned to this license.",
      disabledUser: "Disabled",
      yes: "Yes",
      no: "No",
      verify: "Verify license",
      status: {
        active: "Valid",
        expiring: "Expiring",
        expired: "Expired",
        suspended: "Suspended",
        revoked: "Revoked",
        inactive: "Inactive"
      },
      fields: {
        code: "License code",
        product: "Product",
        status: "Status",
        validUntil: "Valid until",
        daysLeft: "Days left",
        soldTo: "Seller",
        usedBy: "Using company",
        country: "Country",
        users: "Users",
        capacityUsers: "User capacity",
        capacityOperations: "Operation limit",
        capacityStorage: "Storage limit",
        activated: "Activated",
        activatedAt: "Activated on",
        activatedBy: "Activated by",
        createdAt: "Issued on"
      }
    }
  },
  tr: {
    companyLicenses: {
      tab: "Şirket lisansları",
      title: "Şirket lisansları",
      intro: "Şirketinizin kullandığı lisanslar; durum, geçerlilik, kapasite ve her lisansı kullanan kullanıcılarla.",
      companyIntro: "{{company}} şirketinin kullandığı lisanslar; durum, geçerlilik, kapasite ve her lisansı kullanan kullanıcılarla.",
      partialNote: "Tüm kullanıcıların lisans atamasını yalnızca şirket yöneticisi görür; siz kendi atamanızı görürsünüz.",
      total: "Toplam lisans",
      usable: "Kullanımda",
      expiringSoon: "30 gün içinde bitecek",
      expired: "Süresi dolan",
      seats: "Kullanıcı / kapasite",
      nextExpiry: "En yakın bitiş: {{date}}",
      products: "Ürünler",
      search: "Kod, ürün, şirket veya kullanıcı ara",
      statusFilter: "Durum",
      all: "Tümü",
      export: "CSV indir",
      renew: "Yenileme talebi",
      details: "Ayrıntı",
      noLicenses: "Şirketinize bağlı lisans henüz yok.",
      noMatch: "Filtreye uyan lisans yok.",
      loadError: "Lisanslar yüklenemedi.",
      daysLeft: "{{count}} gün kaldı",
      lastDay: "Son gün",
      expiredAgo: "{{count}} gün önce doldu",
      openEnded: "Süresiz",
      defaultCapacity: "varsayılan limit",
      usersTitle: "Bu lisansı kullananlar",
      noUsers: "Bu lisansa atanmış kullanıcı yok.",
      disabledUser: "Pasif",
      yes: "Evet",
      no: "Hayır",
      verify: "Lisansı doğrula",
      status: {
        active: "Geçerli",
        expiring: "Bitmek üzere",
        expired: "Süresi doldu",
        suspended: "Askıda",
        revoked: "İptal edildi",
        inactive: "Pasif"
      },
      fields: {
        code: "Lisans kodu",
        product: "Ürün",
        status: "Durum",
        validUntil: "Geçerlilik tarihi",
        daysLeft: "Kalan gün",
        soldTo: "Satıcı",
        usedBy: "Kullanan şirket",
        country: "Ülke",
        users: "Kullanıcılar",
        capacityUsers: "Kullanıcı kapasitesi",
        capacityOperations: "İşlem limiti",
        capacityStorage: "Depolama limiti",
        activated: "Etkinleştirildi",
        activatedAt: "Etkinleştirme tarihi",
        activatedBy: "Etkinleştiren",
        createdAt: "Düzenlenme tarihi"
      }
    }
  },
  ar: {
    companyLicenses: {
      tab: "تراخيص الشركة",
      title: "تراخيص الشركة",
      intro: "التراخيص التي تستخدمها شركتك، مع الحالة والصلاحية والسعة والمستخدمين على كل ترخيص.",
      companyIntro: "التراخيص التي تستخدمها {{company}}، مع الحالة والصلاحية والسعة والمستخدمين على كل ترخيص.",
      partialNote: "يرى مسؤول الشركة فقط تعيينات التراخيص لجميع المستخدمين؛ أنت ترى تعيينك فقط.",
      total: "إجمالي التراخيص",
      usable: "قيد الاستخدام",
      expiringSoon: "تنتهي خلال 30 يومًا",
      expired: "منتهية",
      seats: "المستخدمون / السعة",
      nextExpiry: "أقرب انتهاء: {{date}}",
      products: "المنتجات",
      search: "ابحث بالرمز أو المنتج أو الشركة أو المستخدم",
      statusFilter: "الحالة",
      all: "الكل",
      export: "تصدير CSV",
      renew: "طلب تجديد",
      details: "التفاصيل",
      noLicenses: "لا توجد تراخيص مرتبطة بشركتك بعد.",
      noMatch: "لا توجد تراخيص مطابقة للتصفية.",
      loadError: "تعذر تحميل التراخيص.",
      daysLeft: "متبقٍ {{count}} يوم",
      lastDay: "اليوم الأخير",
      expiredAgo: "انتهى منذ {{count}} يوم",
      openEnded: "بلا تاريخ انتهاء",
      defaultCapacity: "الحد الافتراضي",
      usersTitle: "المستخدمون على هذا الترخيص",
      noUsers: "لا يوجد مستخدم معيّن لهذا الترخيص.",
      disabledUser: "معطّل",
      yes: "نعم",
      no: "لا",
      verify: "التحقق من الترخيص",
      status: {
        active: "سارٍ",
        expiring: "على وشك الانتهاء",
        expired: "منتهٍ",
        suspended: "معلّق",
        revoked: "ملغى",
        inactive: "غير نشط"
      },
      fields: {
        code: "رمز الترخيص",
        product: "المنتج",
        status: "الحالة",
        validUntil: "صالح حتى",
        daysLeft: "الأيام المتبقية",
        soldTo: "البائع",
        usedBy: "الشركة المستخدمة",
        country: "الدولة",
        users: "المستخدمون",
        capacityUsers: "سعة المستخدمين",
        capacityOperations: "حد العمليات",
        capacityStorage: "حد التخزين",
        activated: "مفعّل",
        activatedAt: "تاريخ التفعيل",
        activatedBy: "فعّله",
        createdAt: "تاريخ الإصدار"
      }
    }
  }
};
